import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, Fragment as _Fragment, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "payment-requests-details-modal-pay" }
const _hoisted_2 = { class: "payment-requests-details-modal-pay__container" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"container__header\"><div class=\"header__title\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M14.536 21.686a.5.5 0 0 0 .937-.024l6.5-19a.496.496 0 0 0-.635-.635l-19 6.5a.5.5 0 0 0-.024.937l7.93 3.18a2 2 0 0 1 1.112 1.11z\"></path><path d=\"m21.854 2.147-10.94 10.939\"></path></svg> Выплата </div></div>", 1)
const _hoisted_4 = { class: "container__content" }
const _hoisted_5 = { class: "content__row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "row__label" }, "Статус выплаты:", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M20 6 9 17l-5-5" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M18 6 6 18" }),
  /*#__PURE__*/_createElementVNode("path", { d: "m6 6 12 12" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs_status = _resolveComponent("bs-status")!
  const _component_bs_button = _resolveComponent("bs-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          (_ctx.paymentRequest.status)
            ? (_openBlock(), _createBlock(_component_bs_status, {
                key: 0,
                color: _ctx.getColor()
              }, {
                default: _withCtx(() => [
                  (_ctx.paymentRequest.status.id === 60)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Оплачен")
                      ], 64))
                    : (_ctx.paymentRequest.status.id === 61)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _createTextVNode("Отказ от оплаты")
                        ], 64))
                      : (_ctx.paymentRequest.status.id === 62)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode("Ожидает оплаты")
                          ], 64))
                        : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["color"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["content__widget", {
                        'widget--green': _ctx.paymentRequest.status && _ctx.paymentRequest.status.id === 60,
                        'widget--red': _ctx.paymentRequest.status && _ctx.paymentRequest.status.id === 61,
                        'widget--message': _ctx.paymentRequest.status && _ctx.paymentRequest.status.id === 60 || _ctx.paymentRequest.status.id === 61
                    }])
        }, [
          (_ctx.paymentRequest.status && _ctx.paymentRequest.status.id === 60)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_7,
                _createTextVNode(" Выплата произведена ")
              ], 64))
            : (_ctx.paymentRequest.status && _ctx.paymentRequest.status.id === 61)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_8,
                  _createTextVNode(" В выплате отказано ")
                ], 64))
              : (_ctx.paymentRequest.status && _ctx.paymentRequest.status.id === 62)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_bs_button, {
                      type: "button",
                      color: "royal-blue",
                      onClick: _ctx.onPay
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Оплатить")
                      ]),
                      _: 1
                    }, 8, ["onClick"]),
                    _createVNode(_component_bs_button, {
                      type: "button",
                      color: "red",
                      onClick: _ctx.onDecline
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Отказать")
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
        ], 2)
      ])
    ])
  ]))
}